import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import { AttendantListDataState } from '@/zustand/interfaces/attendant-list-data';
import { filterAttendantsByStatus } from '@/utils/filter-attendants-by-status';

export const useAttendantListData = create<
  AttendantListDataState,
  [['zustand/persist', unknown]]
>(
  persist(
    (set) => ({
      attendants: null,
      active: null,
      inactive: null,
      setAttendantListData: (attendants) => {
        const { active, inactive } = filterAttendantsByStatus(attendants);
        set({ attendants, active, inactive });
      },
      removeAttendantListData: () =>
        set({
          attendants: null,
          active: null,
          inactive: null
        })
    }),
    {
      name: 'attendantListData',
      storage: createJSONStorage(() => localStorage)
    }
  )
);
